import React from "react";
import getCodedValue from "../../utils/getCodedValue";

const Religion = ({ data }) => (
  <div>
    <h4>Religion</h4>
    {data.length
      ? data.map((religion, index) => (
          <div key={index}>{getCodedValue(religion.valueCodeableConcept)}</div>
        ))
      : "NA"}
  </div>
);

export default Religion;
